module.exports = __webpack_public_path__ + "img/Home.0cfab938.webp";